export const SummaryHeadDataType = Object.freeze({
  userRate: 'userRate',
  sessionCrashRate: 'sessionCrashRate',
  crashNum: 'crashNum',
  crashUser: 'crashUser',
  /** linux专用，崩溃显示发生次数，错误显示设备异常率 */
  linuxDefault: 'linuxDefault',
});

export const SummaryHeadDataTypeUtil = Object.freeze({
  isAccessRelated(type) {
    return type === SummaryHeadDataType.userRate
      || type === SummaryHeadDataType.sessionCrashRate
      || type === SummaryHeadDataType.linuxDefault;
  },
});
